import './_app.scss'

import { NextComponentType } from 'next'
import * as Sentry from '@sentry/node'
import { useEffect } from 'react'
import TagManager from 'react-gtm-module'

import { appWithTranslation } from '../i18n'
import Head from 'next/head'
import { getLanguage } from '../utils/language'
import packageJson from '../package.json'

import { ODXThemeProvider } from '@odkmedia/odx-design-system'

interface Props {
  Component: NextComponentType
  pageProps: any
}

// Note: 현재 배포환경에서 환경변수 주입이 제대로 안 되고 있다.
// 일단 하드코딩 한다.
const SENTRY_DSN = 'https://540f18c67b374136a0f9a5632be58bf3@o302172.ingest.sentry.io/5413578'
const NEXT_PUBLIC_GTM_ID = 'GTM-553KLMM'
const { version } = packageJson
const NEXT_PUBLIC_APP_VERSION = version

if (SENTRY_DSN && NEXT_PUBLIC_APP_VERSION) {
  Sentry.init({
    enabled: process.env.NODE_ENV === 'production',
    dsn: SENTRY_DSN,
    release: version,
  })
  console.log(`[Sentry] Enable Sentry. release: ${NEXT_PUBLIC_APP_VERSION}`)
} else {
  console.log(`[Sentry] parameter invalid. dsn: ${SENTRY_DSN} version: ${NEXT_PUBLIC_APP_VERSION}`)
}

function App({ Component, pageProps }: Props) {
  useEffect(() => {
    const currentLanguage = getLanguage()

    const { user, dataLayer } = pageProps

    const userDataLayer = user
      ? {
          userID: String(user.id),
          equippedPass: user.paidPass,
          isPlusMember: user.paidSubscriptionForDatalayer,
          version: NEXT_PUBLIC_APP_VERSION,
          isKooliUser: user.isKooliUser,
        }
      : {}
    TagManager.initialize({
      gtmId: NEXT_PUBLIC_GTM_ID,
      dataLayer: {
        userLanguage: currentLanguage,
        ...userDataLayer,
        ...dataLayer,
      },
    })
  }, [])

  return (
    <>
      <Head>
        <title>OnDemandKorea</title>
        <meta charSet="UTF-8" />
        <meta name="copyright" content="ODK Media, Inc" />
        <meta name="viewport" content="width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
      </Head>
      <ODXThemeProvider theme="odk">
        <Component {...pageProps} />
      </ODXThemeProvider>
    </>
  )
}

App.getInitialProps = async ({ Component, ctx }: { Component: NextComponentType; ctx: any }) => {
  const { user, dataLayer } = ctx.query
  const defaultPageProps = {
    dataLayer: dataLayer ? JSON.parse(dataLayer) : {},
    user: user ? JSON.parse(user) : null,
  }

  const componentPageProps = Component.getInitialProps ? await Component.getInitialProps(ctx) : {}

  return { pageProps: { ...defaultPageProps, ...componentPageProps } }
}

export default appWithTranslation(App)
